import * as React from "react";
import { DateTime } from "luxon";
import { DateTimePicker } from "@focus/focusUI";
export const MAXDATE = DateTime.fromString("2999-01-01", "yyyy-mm-dd");
export const MINDATE = DateTime.fromString("1957-10-04", "yyyy-mm-dd");
const UTCDateTimePicker = ({ value, precision, onChange, }) => {
    const onPickerChange = (selectedDate) => {
        const dateLocal = DateTime.fromJSDate(selectedDate);
        const dateUTC = dateLocal.setZone("utc", { keepLocalTime: true }).toUTC();
        onChange(dateUTC);
    };
    const newDate = React.useMemo(() => {
        const date = value.setZone("local", { keepLocalTime: true });
        if (date < MINDATE) {
            return MINDATE.toJSDate();
        }
        else if (date > MAXDATE) {
            return MAXDATE.toJSDate();
        }
        return date.toJSDate();
    }, [value.toMillis()]);
    return (React.createElement(DateTimePicker, { canClearSelection: false, onChange: onPickerChange, value: newDate, defaultValue: newDate, datePickerProps: {
            maxDate: MAXDATE.toJSDate(),
            minDate: MINDATE.toJSDate(),
        }, timePickerProps: {
            precision: precision,
            selectAllOnFocus: true,
        }, key: "DatePicker" }));
};
export default UTCDateTimePicker;
//# sourceMappingURL=UTCDateTimePicker.js.map